import { Dispatch, useEffect, useState } from 'react';

import { folderApi, TFolder } from '@_entities/content';

import { useUILayerStore } from '@_shared/stores/useUILayerStore';
import { ContentListAction } from '../../model';
import { ContentListFolderUpdateModal } from '../../ui';

export function useContentListFolderUpdateModal(
	dispatch: Dispatch<ContentListAction>,
	selectedFolderIds: number[],
	closeEditMode: () => void,
) {
	const { pushLayer } = useUILayerStore();
	const [folderlist, setFolderlist] = useState<TFolder[]>([]);

	useEffect(() => {
		folderApi.getFolderList(true, 'manual').then(({ data }) => {
			setFolderlist(data);
		});
	}, []);

	const openContentListFolderUpdateModal = () => {
		pushLayer(
			'modal',
			<ContentListFolderUpdateModal
				dispatch={dispatch}
				folderlist={folderlist}
				folderId={selectedFolderIds.length === 1 ? selectedFolderIds[0] : undefined}
				closeEditMode={closeEditMode}
			/>,
		);
	};

	return {
		openContentListFolderUpdateModal,
	};
}
